import { AMOUNT_TYPE_MULTIPLE, AMOUNT_TYPE_SINGLE, EXPIRATION_TYPE_DATE, EXPIRATION_TYPE_DAYS } from "./constants";
import { isDateValid } from "@/utils/date/valid";
import { REQUIRED_ERROR, DATE_FORMAT_ERROR } from "@/constants/errorFieldValues";
import { formatItemData } from "./formatData";

export const form = {
    amountType: AMOUNT_TYPE_SINGLE,
    category: null,
    type: null,
    name: "",
    serialNumber: "",
    amount: "",
    expirationDate: "",
    productionDate: "",
    purchaseDate: "",
    model: "",
    purchasePlace: "",
    cost: "",
    description: "",
    files: [],
    fileLinks: [],
};

export const serverErrors = {
    serialNumber: "",
};

export const computedErrors = {
    categoryError() {
        return form.category ? null : REQUIRED_ERROR;
    },

    typeError() {
        return form.type ? null : REQUIRED_ERROR;
    },

    serialNumberError() {
        if (form.amountType === AMOUNT_TYPE_MULTIPLE) return null;
        return serverErrors.serialNumber;
    },

    amountError() {
        if (form.amountType === AMOUNT_TYPE_SINGLE) return null;
        return form.amount ? null : REQUIRED_ERROR;
    },

    expirationDateError() {
        if (!form.expirationDate) return null;
        return isDateValid(form.expirationDate) ? null : DATE_FORMAT_ERROR;
    },

    productionDateError() {
        if (!form.productionDate) return null;
        return isDateValid(form.productionDate) ? null : DATE_FORMAT_ERROR;
    },

    purchaseDateError() {
        if (!form.purchaseDate) return null;
        return isDateValid(form.purchaseDate) ? null : DATE_FORMAT_ERROR;
    },
};

export const watchers = {
    "form.serialNumber": function () {
        serverErrors.serialNumber = "";
    },
};

export function getData() {
    const {
        amountType,
        type,
        name,
        amount,
        serialNumber,
        expirationDate,
        productionDate,
        purchaseDate,
        model,
        purchasePlace,
        cost,
        description,
        files,
        fileLinks,
    } = form;

    const oldFiles = fileLinks && fileLinks.map((l) => l.id);

    const params = {
        type: type && type.value,
        name,

        productionDate,
        purchaseDate,
        model,
        purchasePlace,
        cost,
        description,

        expirationDate,

        files,
        oldFiles,
    };

    if (amountType === AMOUNT_TYPE_MULTIPLE) {
        params.multiple = true;
        params.amount = amount;
        params.serialNumber = "";
    } else {
        params.amount = "";
        params.serialNumber = serialNumber;
    }

    return formatItemData(params);
}

export function setData(data, catalog) {
    const {
        type,
        name,
        serialNumber,
        expirationDate,
        productionDate,
        purchaseDate,
        model,
        purchasePlace,
        cost,
        description,
        files,
    } = data;

    const category = catalog.find((c) => c.types.some((t) => t.id === type));

    form.category = category;
    form.type = category ? { value: type } : null;
    form.name = name || "";
    form.serialNumber = serialNumber || "";
    form.expirationDate = expirationDate || "";
    form.productionDate = productionDate || "";
    form.purchaseDate = purchaseDate || "";
    form.model = model;
    form.purchasePlace = purchasePlace || "";
    form.cost = cost || "";
    form.description = description || "";

    form.fileLinks = files;
}

export function reset() {
    form.amountType = AMOUNT_TYPE_SINGLE;
    form.category = null;
    form.type = null;
    form.name = "";
    form.serialNumber = "";
    form.amount = "";

    form.model = "";
    form.purchasePlace = "";
    form.cost = "";
    form.description = "";

    form.productionDate = "";
    form.expirationDate = "";
    form.purchaseDate = "";
}

export function setServerErrors(errors) {
    if (errors.guid) {
        serverErrors.serialNumber = "ТМЦ с указанным серийным номером уже добавлена. Введите другое значение";
    }
}
